import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        nav("/dashboard", { replace: true });
      })
      .catch((e) => setError(errMsg(e)));
  }, [location.hash, nav, setUser]);

  if (!error) return null;
  return (
    <div className="min-h-screen grid place-items-center p-6" data-testid="auth-callback-error">
      <div className="max-w-md text-center">
        <h2 className="text-xl font-bold">Google sign-in not permitted</h2>
        <p className="text-slate-500 mt-2 text-sm">{error}</p>
        <button className="mt-6 text-orange-600 font-semibold" onClick={() => nav("/login", { replace: true })} data-testid="back-to-login">Back to sign in</button>
      </div>
    </div>
  );
}
